import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79b4b7e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "nav-pills",
  "data-testid": "works-filters"
}
const _hoisted_2 = ["tabindex", "on:keyDown", "onClick"]

import { useGettext } from 'vue3-gettext'

interface Props {
  filters: string[],
  selected: string,
  disabled?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WorksFilters',
  props: {
    filters: {},
    selected: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["filterChanged"],
  setup(__props: any, { emit }) {

const props = __props;

const { $gettext } = useGettext()





function changeFilter(filter: string) {
  if (filter === props.selected || props.disabled) {
    return
  }

  emit('filterChanged', filter)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, index) => {
        return (_openBlock(), _createElementBlock("li", { key: filter }, [
          _createElementVNode("a", {
            class: _normalizeClass({ active: (filter === _ctx.selected), disabled: _ctx.disabled }),
            tabindex: index,
            "on:keyDown": ($event: any) => (!_ctx.disabled && changeFilter(filter)),
            onClick: ($event: any) => (!_ctx.disabled && changeFilter(filter))
          }, _toDisplayString(_unref($gettext)(filter)), 43, _hoisted_2)
        ]))
      }), 128))
    ])
  ]))
}
}

})